const UNITS = ['KB', 'MB', 'GB', 'TB'] as const;

/** 1234 → "1.2 KB", 2 GB → "2.0 GB"; a dash for anything that is not a size. */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined || !Number.isFinite(bytes) || bytes < 0) return '—';
  if (bytes < 1024) return `${bytes} B`;
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value >= 100 ? value.toFixed(0) : value.toFixed(1)} ${UNITS[unit]}`;
}

export function shortSha(sha: string | null | undefined, length = 12): string {
  if (!sha) return '—';
  return sha.length > length ? `${sha.slice(0, length)}…` : sha;
}
